import OrgSettingToggle from '../../OrgSecurityControls/DefaultOrgControls/OrgSettingToggle/OrgSettingToggle';

import {
  Typography,
  TypographySize,
  TypographyWeight
} from '~/components/core';
import { Table } from '~/components/core';
import SettingsSection from '~/components/SettingsModal/SettingsSection';
import { useCanAccessSecuritySettings, useOrgSettings } from '~/hooks';

const DefaultIntegrationControls = () => {
  const { orgSettings, isLoading } = useOrgSettings();
  const { userCanAccessSecuritySettings } = useCanAccessSecuritySettings();

  const rows = orgSettings
    ? [
        {
          key: 'orgSettings-integration',
          cells: [
            <div
              className="flex items-center gap-2"
              data-testid="integration-cell-container"
              key="integration"
            >
              <Typography
                size={TypographySize.SMALL}
                weight={TypographyWeight.SEMI_BOLD}
              >
                New Integrations
              </Typography>
            </div>,
            <OrgSettingToggle
              disabled={!userCanAccessSecuritySettings}
              fieldName="defaultIntegrationConfigAccessEnabled"
              key="defaultIntegrationConfigAccessEnabled"
              orgSettings={orgSettings}
            />
          ]
        }
      ]
    : [];

  return (
    <SettingsSection
      description="Control how newly added Integrations are configured by default for your organization."
      title="Default Settings"
    >
      <Table
        columns={[
          {
            title: 'Resource Type',
            width: 'w-1/4'
          },
          {
            title: 'Enabled',
            width: 'w-[12.5%]' // 1/8
          }
        ]}
        data-testid="default-integration-controls-table"
        loading={isLoading}
        noRowsText="No integration settings available at this time."
        rows={rows}
      />
    </SettingsSection>
  );
};

export default DefaultIntegrationControls;
